import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=e504664e&scoped=true&lang=pug"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=e504664e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e504664e",
  null
  
)

export default component.exports